import { render, staticRenderFns } from "./DodTaskList.vue?vue&type=template&id=82b29a6c&scoped=true&"
import script from "./DodTaskList.vue?vue&type=script&lang=js&"
export * from "./DodTaskList.vue?vue&type=script&lang=js&"
import style0 from "./DodTaskList.vue?vue&type=style&index=0&id=82b29a6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b29a6c",
  null
  
)

export default component.exports